import { PaymentFailView } from '@features/payment'
import { PosthogPageView } from '@shared/lib/posthog'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/payment-fail')({
  validateSearch: (search: { code?: string; message?: string; orderId?: string }) => {
    const code = search.code
    const message = search.message
    if (typeof code !== 'string' || typeof message !== 'string') {
      throw new Error('결제 실패 정보를 확인할 수 없어요.')
    }
    return {
      code,
      message,
      orderId: search.orderId,
    }
  },
  component: PaymentFailPage,
  ssr: false,
})

function PaymentFailPage() {
  const { code, message, orderId } = Route.useSearch()

  return (
    <PosthogPageView event="view_payment_fail">
      <PaymentFailView code={code} message={message} orderId={orderId} />
    </PosthogPageView>
  )
}
